import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import TandemLogo from 'assets/images/NavyLogo.svg';

export function RecruitAuthLayout({ children }: { children: React.ReactNode }) {
    return (
        <Root>
            <LogoBar>
                <TandemLogo htmlColor={Colors.darkNavy} style={{ height: 112, width: 112 }} />
            </LogoBar>
            <Content>
                <FormWrapper>{children}</FormWrapper>
            </Content>
        </Root>
    );
}

const Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: Colors.faintGrey,
});

const LogoBar = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '8%',
});

const Content = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
});

const FormWrapper = styled('div')({
    width: 480,
    maxWidth: '100%',
});
